<template>
  <div class="right_body action_body" style="padding:5px 0">
    <Panel>
      <template v-slot:panel-top>
        <ToolBar class="infoActive_rumb"
          @edit="onEditPlatResource"
          @add="onAddPlatResource"         
          :isAdd="isBtn"
          :isEdit="isBtn"> 
          <span
            class="btn infoRight_sub_btn save_btn"
            @click="submitData"
            :isDisable="isDisable"
          >提交数据</span>
        </ToolBar>
      </template>
      <template v-slot:panel-main>
        <!-- <div class="active_rumb"> 
      <span class="txt">客户数据</span>
        </div>-->
        <el-tabs v-model="activeName" @tab-click="handleClick" v-loading="$store.state.isLoading">
          <el-tab-pane label="客户数据" name="base">
            <el-form ref="baseForm" :rules="rules" :model="fromData">
              <div class="coll">
                <h2 class="title">
                  <span>基本信息</span>
                </h2>
                <div class="from_box flex">
                  <div class="item" v-if="isEdit">
                    <span class="txt">客户编号：</span>
                    <el-input
                      v-model="fromData.customerCode"
                      :disabled="isEdit"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </div>

                  <div class="item">
                    <span class="txt">客户描述：</span>
                    <el-input v-model="fromData.customerName" autocomplete="off" placeholder="请输入"></el-input>
                  </div>

                  <div class="item">
                    <span class="txt">客户等级：</span>
                    <el-input v-model="fromData.customerLevel" autocomplete="off" placeholder="请输入"></el-input>
                  </div>

                  <el-form-item class="item" label="联系人：" prop="contact">
                    <el-input
                      type="text"
                      :placeholder="$store.state.remark.contact"
                      v-model="fromData.contact"
                    ></el-input>
                  </el-form-item>
                  <el-form-item class="item" label="电子邮件：" prop="email">
                    <el-input
                      type="text"
                      :placeholder="$store.state.remark.email"
                      v-model="fromData.email"
                    ></el-input>
                  </el-form-item>
                  <el-form-item class="item" label="联系电话：" prop="telephone">
                    <el-input
                      type="text"
                      :placeholder="$store.state.remark.mob"
                      v-model="fromData.telephone"
                      maxlength="11"
                      show-word-limit
                    ></el-input>
                  </el-form-item>

                  <div class="item">
                    <span class="txt">微信：</span>
                    <el-input v-model="fromData.weCat" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">省：</span>
                    <el-input v-model="fromData.proviceDesc" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">市：</span>
                    <el-input v-model="fromData.cityDesc" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">县：</span>
                    <el-input v-model="fromData.countyDesc" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">出生日期：</span>
                    <!-- <el-input v-model="fromData.birthday" autocomplete="off" placeholder="请输入"></el-input> -->
                    <el-date-picker
                      v-model="fromData.birthday"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </div>
                </div>
              </div>
              <div class="coll">
                <h2 class="title">
                  <span>办卡信息</span>
                </h2>
                <div class="from_box flex">
                  <el-form-item class="item" label="办卡月：" prop="cardDate">
                    <el-date-picker
                      v-model="fromData.cardDate"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                  <!-- <el-form-item class="item" label="电子邮件：" prop="email">
                    <el-input
                      type="text"
                      :placeholder="$store.state.remark.email"
                      v-model="fromData.email"
                    ></el-input>
                  </el-form-item>
                  <el-form-item class="item" label="联系电话：" prop="telephone">
                    <el-input
                      type="text"
                      :placeholder="$store.state.remark.mob"
                      v-model="fromData.telephone"
                    ></el-input>
                  </el-form-item> -->
                </div>
              </div>
              <div class="coll">
                <h2 class="title">
                  <span>地址</span>
                </h2>
                <div class="from_box flex">
                  <div class="item">
                    <span class="txt">国家代码：</span>
                    <el-select
                      filterable
                      @change="changContryKeyValue"
                      v-model="fromData.countryCode"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="(item,index) in cities"
                        :key="item.index"
                        :label="item.zh"
                        :value="item.locale"
                      >
                        <span style="float: left">{{ item.locale}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.zh}}</span>
                      </el-option>
                    </el-select>
                  </div>
                  <div class="item">
                    <span class="txt">所在地区：</span>
                    <el-input v-model="fromData.area" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">详细地址：</span> 
                    <el-input v-model="fromData.streetAdress" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                  <div class="item">
                    <span class="txt">邮编：</span>
                    <el-input
                      v-model="fromData.zipCode"
                      oninput="value=value.replace(/[^\d]/g,'')"
                      autocomplete="off"
                      placeholder="请输入"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="coll">
                <h2 class="title">
                  <span>其他信息</span>
                </h2>
                <div class="from_box flex">
                  <div class="item">
                    <span class="txt">增值税登记号：</span>
                    <el-input v-model="fromData.vatRegiNum" autocomplete="off" placeholder="请输入"></el-input>
                  </div>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="客户组织" name="customerOrg">
            <CustomerOrgManPage ref="CustomerOrgMan"></CustomerOrgManPage>
          </el-tab-pane>
        </el-tabs>
      </template>
    </Panel>
  </div>
</template>

<script>
import { customerApi } from "api/base.js";
import countryCode from "mock/countryCode.json";
import areaJson from "mock/area.json";
import ToolBar from "components/btn/listBtn.vue";
import Panel from "components/container/BasePanel.vue";
import CustomerOrgManPage from "./CustomerOrgManPage.vue"
export default {
  components: { ToolBar, Panel,CustomerOrgManPage },
  data() {
    return {
      isBtn:true,
      isEdit: false,
      isDisable: false,
      cities: countryCode,
      areaData: areaJson,
      id: "",
      activeName: "customerOrg",
      selectArea: [],
      fromData: {
        countryCode: "CN" //国家地区默认中国
      },
      rules: {
        email: [
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5.]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱格式",
            trigger: "blur"
          }
        ],
        telephone: [
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机格式",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    this.getInfo();
    this.areaData.forEach((v, k) => {
      if (!v.children) {
        delete v.children;
      }
    });
  },
  methods: {
    /**
     * 注册事件监听
     */
    registerEventListener(){ 
      //点击tab页 
      this.$bus.on('onClickTabPage', this.onClickTabPage);
      //移除tab页
      this.$bus.on('onRemoveTabPage', this.onRemoveTabPage);
    },
    //移除tab页
    onRemoveTabPage(tabName){
       //this.$route.meta.clearCache=true;
       console.log("onRemoveTabPage clearCache="+this.$route.meta.clearCache);
    },  
    //点击tab页 
    onClickTabPage(tabName){
       //this.$route.meta.clearCache=false;
        console.log(" onClickTabPage clearCache="+this.$route.meta.clearCache);
    },
    //获取选中的值
    onProvincesChange(item) {
      let codeStr = this.$refs.myCascader.getCheckedNodes()[0].pathLabels;
      this.selectArea = item;
      codeStr.forEach((v, k) => {
        if (k === 0) {
          this.fromData.proviceDesc = v;
          this.fromData.proviceCode = item[k];
        } else if (k === 1) {
          this.fromData.cityDesc = v;
          this.fromData.cityCode = item[k];
        } else {
          this.fromData.countyDesc = v;
          this.fromData.countyCode = item[k];
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab.name)
      if(tab.name == "customerOrg"){
        this.isBtn = true
      }else{
        this.isBtn = false
      }
    },
    //获取国家代码
    changContryKeyValue(item) {},
    //获取当前的数据 
    async getInfo() {
      let id = this.$route.params.id;
      if (id) {
        this.isEdit = true;
        let res = await this.$get(customerApi.find, { customerId: id });
        const { data, msg, msgCode, code } = res;
        this.selectArea = [data.proviceCode, data.cityCode, data.countyCode];
        if (data) {
          this.fromData = data;
        }
      }
    },
    /**
     * 新增平台资源
     */
		onAddPlatResource(){
      this.$refs.CustomerOrgMan.onAddPlatResource()
    },
    /**
     * 编辑平台资源
     */
    onEditPlatResource(){
      this.$refs.CustomerOrgMan.onEditPlatResource()
    },
    //提交数据
    async submitData() {
      let vm = this;
      let id = this.$route.params.id;
      var postUrl = customerApi.add;
      if (id) {
        //编辑
        postUrl = customerApi.edit;
      }
      if (!this.fromData.customerName) {
        this.$message.error("请选择客户描述");
        return false;
      }
      if (!this.fromData.contact) {
        this.$message.error("请选择联系人");
        return false;
      }
      if (!this.fromData.email) {
        this.$message.error("请选择电子邮箱");
        return false;
      }
      if (!this.fromData.telephone) {
        this.$message.error("请选择联系电话");
        return false;
      }
      if (!this.fromData.area) {
        this.$message.error("请选择所在地区");
        return false;
      }
      if (!this.fromData.streetAdress) {
        this.$message.error("请选择详细地址");
        return false;
      }
      if (!this.fromData.zipCode) {
        this.$message.error("请选择邮编");
        return false;
      }
      if (!this.fromData.vatRegiNum) {
        this.$message.error("请选择增值税号");
        return false;
      }
      this.isDisable = true;
      this.fromData.birthday = this.$moment(
        this.fromData.birthday
      ).format("YYYY-MM-DD");
      this.fromData.cardDate = this.$moment(
        this.fromData.cardDate
      ).format("YYYY-MM-DD");
      console.log(JSON.stringify(this.fromData));
      let res = await this.$post(postUrl, this.fromData); 

      if (res.status) {
        console.log(res);
        let successMsg = id
          ? "客户 " + res.data.customerCode + " 修改成功"
          : "客户" + res.data.customerCode + "创建成功";
        this.$alert(successMsg, "操作提示", {
          confirmButtonText: "确定",
          callback: action => {
            vm.fromData = {};
            // vm.$router.push({ name: "base-customer-list" });
            this.$keepAliveManager.backSourceRoute(this,{name: "base-customer-list"});
          }
        });
        //this.$router.push({name:'base-customer-detail',params:{id:data.customerId}});
      } else {
        this.$message.error(res.errorMsg);
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
